import React, {ReactNode} from 'react';
import { ButtonProps } from "@material-ui/core";

import { InterviewStatus } from "../types";

import {
    StyledDateRangeOutlinedIcon,
    StyledEventBusyOutlinedIcon,
    StyledEventOutlinedIcon,
    StyledEventAvailableIcon,
    GreenActionButton,
    ActionButton
} from "./InterviewStatusButton.styles";

interface InterviewStatusButtonProps {
    interviewStatus: InterviewStatus;
    endIcon?: ReactNode;
    onNoShowButtonClick?: () => void;
    onSetInterviewStatus?: (newInterviewStatus: InterviewStatus) => Promise<void>;
    onApplicationActionsPopupOpen?: () => void;
}

const ButtonIconByInterviewStatus =  {
    [InterviewStatus.nostatus]: <StyledDateRangeOutlinedIcon />,
    [InterviewStatus.noshow]: <StyledEventBusyOutlinedIcon />,
    [InterviewStatus.scheduled]: <StyledEventOutlinedIcon />,
    [InterviewStatus.interviewed]: <StyledEventAvailableIcon />,
}

const ButtonComponentByInterviewStatus =  {
    [InterviewStatus.nostatus]: ActionButton,
    [InterviewStatus.noshow]: ActionButton,
    [InterviewStatus.scheduled]: GreenActionButton,
    [InterviewStatus.interviewed]: GreenActionButton,
}

const buttonLabelByInterviewStatus = {
    [InterviewStatus.nostatus]: "Update Interview Status",
    [InterviewStatus.noshow]: "No show",
    [InterviewStatus.scheduled]: "Interview Scheduled",
    [InterviewStatus.interviewed]: "Interviewed",
}

const buttonVariantByInterviewStatus = {
    [InterviewStatus.nostatus]: "contained",
    [InterviewStatus.noshow]: "outlined",
    [InterviewStatus.scheduled]: "contained",
    [InterviewStatus.interviewed]: "contained",
}


const InterviewStatusButton = ({
                                   interviewStatus,
                                   endIcon,
                                   onNoShowButtonClick,
                                   onSetInterviewStatus,
                                   onApplicationActionsPopupOpen
}: InterviewStatusButtonProps) => {
    const onClick = async () => {
        if (onApplicationActionsPopupOpen) {
            onApplicationActionsPopupOpen();
        } else if (onNoShowButtonClick && interviewStatus === InterviewStatus.noshow) {
            onNoShowButtonClick();
        } else if (onSetInterviewStatus) {
            await onSetInterviewStatus(interviewStatus);
        }
    }

    const Component = ButtonComponentByInterviewStatus[interviewStatus];

    return (
        <Component
            variant={buttonVariantByInterviewStatus[interviewStatus] as ButtonProps['variant']}
            onClick={onClick}
            startIcon={ButtonIconByInterviewStatus[interviewStatus]}
            endIcon={endIcon}
            color="primary"
            size="large"
            id="interview-status-button"
            className="bigButtonInNewStyle"
        >
            {buttonLabelByInterviewStatus[interviewStatus]}
        </Component>
    )
}

export default InterviewStatusButton;
